import { type ConfigurationImages } from '@tmdb-graphql-api/schema/types';
import { type ImageSize } from '../enums/imageSizes.ts';

export const buildImagePath = (
  path: string | null | undefined,
  type: ImageSize,
  size: number,
  images: ConfigurationImages,
) => (path ? `${images.secureBaseUrl}/${String(images[type][size])}/${path}` : '/images/fallback.jpg');
